var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Header'),_c('router-view'),(this.$router.history.current.path === '/contactus')?_c('div',[_c('ContactFooter',{attrs:{"chosenPackageValue":_vm.chosenPackage}})],1):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }